// extracted by mini-css-extract-plugin
export default {"hero":"MainSilder_hero__PYHs4","image":"MainSilder_image__ZoZ8S"};